// extracted by mini-css-extract-plugin
export default {"languageSwitcher":"LanguageSwitcher_languageSwitcher__0D4mV","languageFlag":"LanguageSwitcher_languageFlag__3G5KR"};